import { trpc } from './trpc';

/**
 * Hook to list external requests with pagination and filters
 */
export const useExternalRequestsList = (
    queryInput: {
        search?: string;
        sortBy?: { field: string; direction: 'asc' | 'desc' };
        pagination?: { page: number; pageSize: number };
        filters?: Record<string, any>;
    },
    autoReload = false,
) => {
    return trpc.externalRequests.list.useQuery(queryInput, {
        staleTime: autoReload ? 0 : 10000,
        refetchOnWindowFocus: false,
        refetchInterval: autoReload ? 5000 : false,
    });
};

/**
 * Hook to get details of a single external request
 */
export const useExternalRequestDetails = (id: string, enabled = true) => {
    return trpc.externalRequests.getById.useQuery(
        { id },
        {
            enabled: enabled && !!id,
            staleTime: 30000,
        },
    );
};

/**
 * Hook to get external request statistics
 */
export const useExternalRequestStats = (
    timeRange: '1h' | '24h' | '7d' | '30d' = '24h',
    requestType?: 'pixel_tracking' | 'webhook_delivery' | 'api_integration',
) => {
    return trpc.externalRequests.getStats.useQuery(
        { timeRange, requestType },
        {
            staleTime: 60000,
        },
    );
};

